<div class='selection'>
  <span class="option-and-icon">
    <span class='material-symbols-outlined' [class]='selection?.className'>{{selection?.icon}}</span>
    {{selection?.displayValue}}
  </span>
</div>